import { ChangeEvent, FC } from "react";
import {
  Box,
  createStyles,
  FormControlLabel,
  makeStyles,
  Switch as MUISwitch,
  Typography,
} from "@material-ui/core";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(16px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: theme.custom.palette.purple.main,
          opacity: 1,
          border: "none",
        },
      },
      "&$focusVisible $thumb": {
        color: theme.custom.palette.purple.main,
        border: "6px solid #fff",
      },
      "&$disabled": {
        color: theme.palette.grey[50],
        "& + $track": {
          backgroundColor: theme.custom.palette.purple.light,
          opacity: 0.7,
        },
      },
    },
    thumb: {
      width: 18,
      height: 18,
      marginTop: 3,
      marginLeft: 3,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
    },
    checked: {},
    focusVisible: {},
    disabled: {
      "&$checked": {
        "& + $track": {
          backgroundColor: theme.custom.palette.purple.light,
        },
      },
      "&:not($checked) + $track": {
        backgroundColor: theme.palette.grey[50],
        border: `1px solid ${theme.palette.grey[200]}`,
        opacity: 0.7,
      },
      "&$focusVisible $thumb": {
        color: theme.custom.palette.purple.light,
      },
    },
  }),
);

interface SwitchProps {
  checked: boolean;
  disabled?: boolean;
  label: string;
  subLabel?: string;
  name?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const Switch: FC<SwitchProps> = ({
  checked,
  disabled,
  label,
  subLabel,
  name,
  onChange,
}) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      control={
        <MUISwitch
          name={name}
          focusVisibleClassName={classes.focusVisible}
          disableRipple
          classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
            disabled: classes.disabled,
          }}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
      }
      label={
        !!subLabel ? (
          <>
            <Typography>{label}</Typography>
            <Typography component="div" variant="caption">
              <Box fontSize={10} textAlign="left">
                {subLabel}
              </Box>
            </Typography>
          </>
        ) : (
          <Typography>{label}</Typography>
        )
      }
    />
  );
};

export default Switch;
